// Immagine locale (WebP in src/assets), caricata solo quando serve
const Image = ({ src, alt, width, height }) => (
  <img
    src={src}
    alt={alt}
    width={width}
    height={height}
    loading='lazy'
    decoding='async'
  />
)

export default Image
